import { createBrowserHistory } from 'history'

// Shared global history
const browserHistory = createBrowserHistory()

export default browserHistory
